/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-useless-escape */
import React from 'react';

import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import Container from '@material-ui/core/Container';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';

import DrawShape from 'components/common/DrawShape';
import RequiredField from 'components/common/components/RequiredField';
import { endAdornmentProps, formStyles } from 'consts/styles/Form';
import Icons from 'consts/icons';

import ButtonsUseStyles from 'consts/styles/Buttons';

import { userStyles } from 'consts/styles/User';

const OrganizationsFormRender = props => {
  const {
    strings,
    values,
    handleChange,
    add,
    drawnGeometry,
    onGeometryChange,
    buttonText,
    newOrganization,
    errors,
    setErrors,
  } = props;
  const [toggleEdit, setToggleEdit] = React.useState(!!values.geojson);

  const formClasses = formStyles();
  const classesUser = userStyles();
  const classesButtons = ButtonsUseStyles();

  const [isDrawing, setIsDrawing] = React.useState(true);

  const useString = () => {
    const language = useSelector(state => state.language);
    return language;
  };
  const { placeholderForm } = useString().areas;

  React.useEffect(() => {
    setErrors({ ...errors, map: !isDrawing });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDrawing]);

  const helperTextForm = type => {
    if (type === 'name')
      return `${placeholderForm.required +
        placeholderForm.text +
        placeholderForm.nameExsits_}.`;

    if (type === 'text') return placeholderForm.required + placeholderForm.text;
    if (type === 'number')
      return placeholderForm.required + placeholderForm.number;
    if (type === 'phone')
      return placeholderForm.required + placeholderForm.phone;
    return placeholderForm.required;
  };

  return (
    <Container
      component="main"
      maxWidth="md"
      className={`${classesUser.User}__wrapper__content__container`}
    >
      <div className={`${formClasses.Form}__overflow-component`}>
        <form
          className={`${formClasses.Form}__overflow-component ${formClasses.Form}__overflow-component--small`}
          noValidate
        >
          {!newOrganization && values.geojson && (
            <Grid container spacing={2} justifyContent="flex-end">
              {!toggleEdit ? (
                <Grid
                  item
                  xs={4}
                  className={`${formClasses.Form}__text-field ${formClasses.Form}--flex`}
                >
                  <span>{strings.formFields.editInform_}</span>
                </Grid>
              ) : (
                ''
              )}
              <Grid item xs={4}></Grid>
              <Grid item xs={4}>
                <Button
                  onClick={() => setToggleEdit(!toggleEdit)}
                  type="button"
                  fullWidth
                  startIcon={<Icons.Actions.Edit2 />}
                  className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
                >
                  {!toggleEdit
                    ? strings.formFields.cancelEditButton_
                    : strings.formFields.editButton_}
                </Button>
              </Grid>
            </Grid>
          )}
          <Grid container spacing={2}>
            <Grid item s={12} sm={6}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: errors.name,
                })}
                htmlFor="name"
              >
                {strings.formFields.name_}*
              </label>
              <TextField
                autoComplete="name"
                inputProps={{
                  placeholder: strings.formFields.name_ + placeholderForm.text,
                  pattern: '[a-zA-Z]{3,50}',
                  maxLength: 50,
                }}
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                error={errors.name}
                name="name"
                variant="outlined"
                autoFocus
                required
                fullWidth
                id="name"
                onChange={handleChange}
                value={values.name}
                disabled={toggleEdit}
                size="small"
                helperText={errors.name ? helperTextForm('text') : ''}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: errors.phone,
                })}
                htmlFor="phone"
              >
                {strings.formFields.phone_}*
              </label>
              <TextField
                variant="outlined"
                required
                error={errors.phone}
                inputProps={{
                  placeholder: placeholderForm.phonePattern,
                  pattern: '[0-9]{9}',
                }}
                type="tel"
                fullWidth
                id="phone"
                name="phone"
                autoComplete="phone"
                onChange={handleChange}
                value={values.phone}
                disabled={toggleEdit}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={errors.phone ? helperTextForm('phone') : ''}
              />
            </Grid>
            <Grid item s={12} sm={4}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: errors.city,
                })}
                htmlFor="city"
              >
                {strings.formFields.city_}
              </label>
              <TextField
                autoComplete="city"
                name="city"
                inputProps={{
                  placeholder: strings.formFields.city_ + placeholderForm.text,
                  pattern: '[a-zA-Z]{3,50}',
                  maxLength: 50,
                }}
                error={errors.city}
                variant="outlined"
                required
                fullWidth
                id="city"
                onChange={handleChange}
                value={values.city}
                disabled={toggleEdit}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={errors.city ? helperTextForm('text') : ''}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: errors.street,
                })}
                htmlFor="street"
              >
                {strings.formFields.street_}
              </label>
              <TextField
                variant="outlined"
                required
                error={errors.street}
                inputProps={{
                  placeholder:
                    strings.formFields.street_ + placeholderForm.text,
                  pattern: '([a-zA-Z0-9]{2,})(?:-*)([a-zA-Z0-9]+)',
                  maxLength: 50,
                }}
                fullWidth
                id="street"
                name="street"
                autoComplete="street"
                onChange={handleChange}
                value={values.street}
                disabled={toggleEdit}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={errors.street ? helperTextForm('other') : ''}
              />
            </Grid>
            <Grid item xs={4} sm={4}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: errors.number,
                })}
                htmlFor="number"
              >
                {strings.formFields.number_}
              </label>
              <TextField
                variant="outlined"
                required
                fullWidth
                error={errors.number}
                inputProps={{
                  placeholder:
                    strings.formFields.number_ + placeholderForm.text,
                  pattern: '[0-9a-zA-Z]',
                  min: 0,
                }}
                id="number"
                name="number"
                autoComplete="number"
                onChange={handleChange}
                value={values.number}
                disabled={toggleEdit}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={errors.number ? helperTextForm('other') : ''}
              />
            </Grid>
            <Grid item xs={12}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: errors.email,
                })}
                htmlFor="email"
              >
                {strings.formFields.email_}*
              </label>
              <TextField
                variant="outlined"
                required
                fullWidth
                error={errors.email}
                type="email"
                inputProps={{
                  placeholder:
                    strings.formFields.email_ + placeholderForm.email,
                }}
                id="email"
                name="email"
                autoComplete="email"
                onChange={handleChange}
                value={values.email}
                disabled={toggleEdit}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={errors.email ? helperTextForm('email') : ''}
              />
            </Grid>
            <Grid item xs={12}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: errors.nip,
                })}
                htmlFor="nip"
              >
                {strings.formFields.nip_}*
              </label>
              <TextField
                variant="outlined"
                required
                fullWidth
                error={errors.nip}
                inputProps={{
                  placeholder: strings.formFields.nip_ + placeholderForm.number,
                  pattern: '[0-9]{10}',
                  minLength: '10',
                  maxLength: '10',
                }}
                id="nip"
                name="nip"
                autoComplete="nip"
                onChange={handleChange}
                value={values.nip}
                disabled={toggleEdit}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={errors.nip ? helperTextForm('number') : ''}
              />
            </Grid>
            <Grid item xs={12}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: errors.regon,
                })}
                htmlFor="regon"
              >
                {strings.formFields.regon_}*
              </label>
              <TextField
                variant="outlined"
                required
                fullWidth
                error={errors.regon}
                inputProps={{
                  placeholder:
                    strings.formFields.regon_ + placeholderForm.number,
                  pattern: '[0-9]{9,14}',
                  minLength: '9',
                  maxLength: '14',
                }}
                id="regon"
                name="regon"
                autoComplete="regon"
                onChange={handleChange}
                value={values.regon}
                disabled={toggleEdit}
                size="small"
                InputProps={{
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={errors.regon ? helperTextForm('number') : ''}
              />
            </Grid>
            <Grid item xs={12}>
              <label
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: errors.buffer,
                })}
                htmlFor="buffer"
              >
                {strings.formFields.buffer_}*
              </label>
              <TextField
                variant="outlined"
                type="number"
                required
                fullWidth
                error={errors.buffer}
                id="buffer"
                name="buffer"
                autoComplete="buffer"
                onChange={handleChange}
                value={values.buffer}
                disabled={toggleEdit}
                size="small"
                InputProps={{
                  endAdornment: endAdornmentProps('[m]'),
                  classes: {
                    input: `${formClasses.Form}__text-field`,
                    focused: `${formClasses.Form}__text-field--focused`,
                  },
                }}
                helperText={errors.buffer ? helperTextForm('number') : ''}
              />
            </Grid>
          </Grid>
          <Grid className={`${formClasses.Form}__map`} item xs={12}>
            {!toggleEdit && (
              <h5 className={`${formClasses.Form}__text-field`}>
                {strings.formFields.drawOrg_}*
              </h5>
            )}
            <DrawShape
              drawnGeometry={drawnGeometry}
              onGeometryChange={onGeometryChange}
              editing={toggleEdit}
              setIsDrawing={setIsDrawing}
            />
            <Container component="main">
              <FormHelperText
                className={clsx(`${formClasses.Form}__label`, {
                  [`${formClasses.Form}__text-field__form-helper--error`]: errors.map,
                })}
              >
                {errors.map ? placeholderForm.required : <>&nbsp;</>}
              </FormHelperText>
            </Container>
          </Grid>
          <Button
            type="button"
            fullWidth
            disabled={toggleEdit}
            onClick={add}
            className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}`}
          >
            {buttonText}
          </Button>
        </form>
        <RequiredField />
      </div>
    </Container>
  );
};
OrganizationsFormRender.propTypes = {
  strings: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  newOrganization: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  add: PropTypes.func.isRequired,
  drawnGeometry: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.instanceOf(null).isRequired,
  ]),
  onGeometryChange: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  errors: PropTypes.object.isRequired,
  setErrors: PropTypes.func.isRequired,
};

export default OrganizationsFormRender;
